import { plainToClass } from "class-transformer";

import { Contact } from "../models/Contact";
import type { User } from "../models/User";

import { transformUserBirthdayToDate } from "./transformUserBirthdayToDate";

export function transformUserToContact(user: User): Contact {
    const rawContact: Contact = {
        birthdayAt: transformUserBirthdayToDate(user.birthdayAt),
        countryId: user.countryId!,
        email: user.email!,
        firstName: user.firstName,
        lastName: user.lastName,
        phoneNumber: user.phoneNumber,
    };

    return plainToClass(Contact, rawContact);
}
